import { LinesApiFactory, Line } from '@/api'
import { BaseMasterListRequest } from '@/requests/baseRequest'
import { AxiosPromise } from 'axios'
/**
 * 線名一覧取得処理
 */
export class ListRequest extends BaseMasterListRequest {
  protected request(): AxiosPromise<Array<Line>> {
    const api = LinesApiFactory()
    return api.linesList()
  }
}
